export default __webpack_public_path__ + "static/media/caret-up-icon.bfee493c.svg";